import type { ReactNode } from "react";

import categoryService from "app/common/services/categoryService";
import { createUniqueListOfAllDomains } from "pro-features/components/DomainsFilter/Utils";
import {
    DOMAINS,
    INCLUDE_EXCLUDE_KEYWORDS,
    INCLUDE_EXCLUDE_TITLE,
    INCLUDE_EXCLUDE_URL,
    SELECTED_CATEGORY,
} from "app/components/widget/widget-filters/components/consts";
import { translate } from "app/filters/i18nFilter";
import type { ActivationObjectSchema } from "app/pages/activation/types/api";

import { parseIncludeExcludeForTooltip } from "../TableWebsiteKeywordsDashboardConsts";

const URLS = "URLs";
const KEYWORDS = "Keywords";
const TITLES = "Titles";

export type FilterLogicFunction = (filters: any) => Promise<{ divElements: ReactNode; divCount: number } | null>;

export const createSearchAdsWidgetFiltersMap = (
    activationSets: ActivationObjectSchema[],
): Record<string, FilterLogicFunction> => ({
    [INCLUDE_EXCLUDE_KEYWORDS]: async (filters) =>
        filters.multiIncludeExcludeKeywords
            ? await parseIncludeExcludeForTooltip(JSON.parse(filters.multiIncludeExcludeKeywords), KEYWORDS)
            : null,
    [INCLUDE_EXCLUDE_URL]: async (filters) =>
        filters.multiIncludeExcludeUrl
            ? await parseIncludeExcludeForTooltip(JSON.parse(filters.multiIncludeExcludeUrl), URLS)
            : null,
    [INCLUDE_EXCLUDE_TITLE]: async (filters) =>
        filters.multiIncludeExcludeTitle
            ? await parseIncludeExcludeForTooltip(JSON.parse(filters.multiIncludeExcludeTitle), TITLES)
            : null,

    [DOMAINS]: async (filters) => {
        const numberOfDomains = createUniqueListOfAllDomains(filters.domains?.split(","), activationSets)?.split(
            ",",
        ).length;
        return filters.domains
            ? {
                  divCount: 1,
                  divElements: translate("analysis.source.search.keywords.search.ads.filters.dashboard.domains", {
                      domains: numberOfDomains,
                  }),
              }
            : { divCount: 0, divElements: null };
    },

    [SELECTED_CATEGORY]: async (filters) => {
        if (!filters.selectedCategory) {
            return { divCount: 0, divElements: null };
        }
        const selectedCategories = filters.selectedCategory.split(",");
        const categoryNames = selectedCategories.map(
            (category) => categoryService.getCategory(category)?.text ?? category.replaceAll("_", " "),
        );
        return {
            divCount: 1,
            divElements: translate("dashboard.metrics.categories.filter.subtitle.tooltip", {
                categoryNames: categoryNames.join(", "),
            }),
        };
    },
});

export const searchAdsTableWidgetAPIParams = [
    INCLUDE_EXCLUDE_KEYWORDS,
    INCLUDE_EXCLUDE_URL,
    INCLUDE_EXCLUDE_TITLE,
    SELECTED_CATEGORY,
    DOMAINS,
];
